module.exports = __webpack_public_path__ + "static/media/fullscreen-w64.b6e23ac3.svg";